import axios from "axios";
import { get } from "lodash";
import { toastr } from "react-redux-toastr";
import { Group } from "../../utils/logger";

import {
  CAMPAIGN_ERROR,
  CAMPAIGN_LOADING,
  SET_CAMPAIGNS,
  CAMPAIGN_DATABASE_UPDATE,
  CAMPAIGN_DATABASE_UPDATING,
  CAMPAIGN_DATABASE_UPDATE_ERROR,
} from "../constants";
import { verifyIsInternalUser } from "../reducers/userReducer";

const LoggerGroup = new Group("Campaign Actions", { disable: true });

export const campaignLoading = (type) => (dispatch) => {
  dispatch({ type: CAMPAIGN_LOADING, payload: type });
};

export const getCampaigns = () => (dispatch, getState) => {
  let isInternalUser = false;
  LoggerGroup.emit(" [i] Fetching Campaign Result For Filter: ");
  dispatch(campaignLoading(CAMPAIGN_LOADING));

  if (getState().user && getState().user.user)
    isInternalUser = verifyIsInternalUser(getState().user.user);

  return axios
    .get(`campaign/list`)
    .then(async (res) => {
      let campaignResult = get(res, "data.list");
      //convert to chicago
      if (campaignResult) {
        for (let i = 0; i < campaignResult.length; i++) {
          if (campaignResult[i].updated_at) {
            campaignResult[i].updated_at = new Date(
              campaignResult[i].updated_at
            ).toLocaleString("en-US", { timeZone: "America/Chicago" });
          }
        }
        LoggerGroup.emit("  [i] Campaign List ", { table: campaignResult }).end();
        if (isInternalUser) dispatch({ type: SET_CAMPAIGNS, payload: campaignResult });
        if (!isInternalUser) {
          dispatch({
            type: SET_CAMPAIGNS,
            payload: campaignResult.filter((item) => item.company_code === "Illinois"),
          });
        }
      } else {
        dispatch({ type: SET_CAMPAIGNS, payload: [] });
      }
    })
    .catch((err) => {
      const error_message = get(err, "response.data.error");
      toastr.error("Campaign Listing Error", error_message);
      LoggerGroup.emit({ warn: "[i] Error fetching Campaign List" }, { dir: error_message }).end();
      dispatch({
        type: CAMPAIGN_ERROR,
        payload: { error_message: `Error fetching campaign List`, internal_error: err },
      });

      dispatch({
        type: SET_CAMPAIGNS,
        payload: [],
      });
    });
};

export const updateCampaign = (campaignDetail) => (dispatch, getState) => {
  LoggerGroup.emit(" [i] Updating Campaign : ", campaignDetail);
  dispatch({ type: CAMPAIGN_DATABASE_UPDATING, payload: campaignDetail });
  return axios
    .post(`campaign/${campaignDetail.id}`, campaignDetail)
    .then((res) => {
      toastr.success(
        "Success",
        `Campaign Call Details updated: ${campaignDetail.company_code}-${campaignDetail.type}-${campaignDetail.subtype}`
      );
      dispatch(getCampaigns()); //refresh campaigns list
      dispatch({ type: CAMPAIGN_DATABASE_UPDATE, payload: null });
    })
    .catch((err) => {
      const error_message = get(err, "response.data.error");
      toastr.error("Error!! Campaign call details update failure", error_message);
      LoggerGroup.emit(
        { warn: `[i] Error Updating Campaign ${campaignDetail}` },
        { dir: error_message }
      ).end();
      dispatch(getCampaigns()); //refresh campaigns list
      dispatch({
        type: CAMPAIGN_DATABASE_UPDATE_ERROR,
        payload: {
          error_message: `Error updating campaign ${campaignDetail.id}`,
          internal_error: err,
        },
      });
    });
};
